<template>
    <tr
        class="time-row"
        :class="{ editable }"
    >
        <td
            colspan="2"
            class="edit-row"
        >
            {{ formattedStart }}
            -
            {{ formattedEnd || $t('offen') }}

            <div
                v-if="editable"
                class="edit-icons"
            >
                <icon-edit @click="$emit('edit')" />
            </div>
        </td>
    </tr>
</template>

<script>
import IconEdit from '../../common/icon/IconEdit';
import moment from 'moment';

export default {
    name: 'KgrMemberAttendanceTimeRow',
    components: { IconEdit },
    props: {
        start: {
            type: String,
            required: true,
        },
        end: {
            type: String,
            required: false,
        },
        isCurrentDay: {
            type: Boolean,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        formattedStart() {
            return moment(this.start).format('HH:mm');
        },
        formattedEnd() {
            return this.end ? moment(this.end).format('HH:mm') : null;
        },
        editable() {
            return this.isEditable && ((this.isCurrentDay && this.formattedEnd !== null) || (!this.isCurrentDay && this.formattedEnd === null));
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .edit-icons {
    display: inline;
}

.time-row {
    line-height: 34px;
    vertical-align: top;
}

.edit-row {
    white-space: nowrap;
}
</style>
